import * as XLSX from "xlsx";

/**
 * Reusable function to export data to Excel
 *
 * @param {Array} data - The raw data array (e.g., from API)
 * @param {Array} columnsConfig - Array of column definitions for export
 *   Each object should have:
 *     - header: string (column header in Excel)
 *     - key: string | function (property path like "employee.phone" or accessor function)
 * @param {string} fileName - Name of the downloaded file (without .xlsx)
 * @param {string} sheetName - Name of the sheet (default: "Data")
 * @param {Array} [columnWidths] - Optional array of { wch: number } for column widths
 */
const exportToExcel = ({
  data = [],
  columnsConfig = [],
  fileName = "export",
  sheetName = "Data",
  columnWidths = [],
}) => {
  if (!data || data.length === 0) {
    console.warn("No data to export");
    return;
  }

  if (columnsConfig.length === 0) {
    console.warn("No columns configured for export");
    return;
  }

  // Transform data according to columnsConfig
  const exportData = data.map((row) => {
    const rowData = {};
    columnsConfig.forEach((col) => {
      if (typeof col.key === "function") {
        rowData[col.header] = col.key(row);
      } else {
        // Support nested keys like "employee.phone"
        const keys = col.key.split(".");
        let value = row;
        for (const k of keys) {
          value = value?.[k];
        }
        rowData[col.header] = value ?? "";
      }
    });
    return rowData;
  });

  // Create worksheet
  const worksheet = XLSX.utils.json_to_sheet(exportData);

  // Apply column widths if provided
  if (columnWidths.length > 0) {
    worksheet["!cols"] = columnWidths;
  }

  // Create workbook and append sheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  // Download file
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};

export default exportToExcel;
